import * as actionTypes from '../Actions/MFACodeActionTypes';

const axiosPayLoad = {
  payload: null,
  validateOtpCount: 0
};
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GENERATE_OTP:
      return { ...state, otpResponse: action.otpResponse };
    case actionTypes.VALIDATE_OTP:
      return { ...state, validateOtpResponse: action.validateOtpResponse };
    case actionTypes.VALIDATE_OTP_COUNT:
      return { ...state, validateOtpCount: state.validateOtpCount + 1 };
      case actionTypes.VALIDATE_OTP_COUNT_RESET:
        return { ...state, validateOtpCount: 0 };
    default: return state;
  }
};

export default reducer;
